import { render, staticRenderFns } from "./orgOption.vue?vue&type=template&id=b7b8aa86"
import script from "./orgOption.vue?vue&type=script&lang=js"
export * from "./orgOption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports